import AlertHistory, { AlertHistoryAttributes } from '@/models/AlertHistory'

export default class AlertHistories {
  public histories: AlertHistory[]

  constructor(historyAttributes: AlertHistoryAttributes[]) {
    this.histories = []

    historyAttributes.forEach(attrs => {
      this.histories.push(new AlertHistory(attrs))
    })
  }
}
